import React, { useState, useEffect } from "react";
import images from "../../../images";
import { useTranslation } from "react-i18next";

const TipsQuest = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Check if it's first login
    const isFirstLogin = localStorage.getItem("isFirstLogin");

    if (isFirstLogin === "true") {
      // Set showQuestTips to true on first login
      localStorage.setItem("showQuestTips", "true");
      setIsVisible(true);
    } else {
      // Check if tips should be shown
      const shouldShowTips = localStorage.getItem("showQuestTips");
      if (shouldShowTips === "true") {
        setIsVisible(true);
      }
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("isFirstLogin", "false");

    localStorage.setItem("showQuestTips", "false");
  };

  if (!isVisible) return null;

  return (
    <div className="bg-[#253FF6] rounded-md px-4 py-2 w-full relative">
      {/* Close Button */}
      <button
        onClick={handleClose}
        className="absolute top-1.5 right-1.5 hover:bg-white hover:bg-opacity-20 rounded-full transition-colors duration-200"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      {/* Content */}
      <div className="flex gap-3 items-center px-4 py-2">
        <div className="">
          <img
            src={images.TipsQuestIcon}
            alt=""
            className="w-[67.88px] h-[64px] object-contain"
          />
        </div>
        <div className="flex flex-col gap-1 w-[240px]">
          <h2 className="text-white text-xl font-bold">
            {t("tips.questTitle")}
          </h2>
          <p className="text-white text-xs font-medium">
            {t("tips.questBody")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TipsQuest;
